<template>
  <li v-if="isVisible" class="nav-group" :class="`${toggled ? 'opened-dropdown': 'closed-dropdown'}`">
    <button class="nav-group-title" @click="toggled = !toggled" id="monitor-button" :aria-expanded="toggled" aria-controls="monitor-expanded">
      <i class="k-asset-icon fa-duotone fa-magnifying-glass-chart" aria-hidden="true"></i>
      <span class="nav-group-title-text">Monitor</span>
      <span v-if="showOtjBubble" class="count-bubble" :class="`${store.isSidebarOpen ? '' : 'collapsed-count-bubble'}`" title="OTJs to review" :aria-label="`${otjsToReview} OTJs to review`">
        {{ otjsToReview }}
      </span>
      <i class="fas fa-angle-down" aria-hidden="true"></i>
    </button>
    <ul class="second-level" id="monitor-expanded" aria-labelledby="monitor-button" :hidden="!toggled">
      <li v-if="$permissions.hasPermission('access_programme_summary')" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{  name: 'monitor_programme_summary'}">
            <span>Programme Summary</span>
          </router-link>
        </div>
      </li>
      <li v-if="$permissions.hasPermission('access_meetings_inbox')" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'meetings_inbox' }">
            <span>Meetings Inbox</span>
          </router-link>
        </div>
      </li>
      <li v-if="$permissions.hasPermission('access_otj_inbox')" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'otj_inbox' }" class="nav-link-count">
            <span>O.T.J. Inbox</span>
            <span v-if="otjsToReview" class="count-bubble" :aria-label="`${otjsToReview} OTJs to review`">{{ otjsToReview }}</span>
          </router-link>
        </div>
      </li>
      <li v-if="$permissions.hasPermission('access_project_inbox') && $featureFlags.isEnabled('kate-projects-dashboard')" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'project_inbox' }">
            <span>Project Inbox</span>
          </router-link>
        </div>
      </li>
      <li v-if="$permissions.hasPermission('access_employer_dashboard')" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'employer_learner_summary' }">
            <span>Employer Summary</span>
          </router-link>
        </div>
      </li>
    </ul>
  </li>
</template>

<style>
/* == Monitor Count Bubble == */
.sidebar-panel.collapsed .count-bubble.collapsed-count-bubble {
  position: absolute;
  right: 0;
  bottom: 0;
}

.sidebar-panel.collapsed:hover .count-bubble.collapsed-count-bubble {
  display: none;
}

</style>

<style scoped>
.count-bubble {
  flex: none;
  margin: 0;
}

.sidebar-panel .nav-group .nav-sub-group a.nav-link-count {
  display: flex;
  justify-content: space-between;
}

.nav-group {
  list-style: none;
}
</style>

<script>
import useGlobalStore from '@stores/global';
import SidebarEntryMixin from '@mixins/sidebar-entry-mixin';
import SidebarMixin from '@mixins/sidebar-mixin';

const REQUIRED_PERMISSIONS = [
  'access_programme_summary',
  'access_meetings_inbox',
  'access_otj_inbox',
  'access_project_inbox',
  'access_employer_dashboard',
];

export default {
  mixins: [SidebarEntryMixin, SidebarMixin],

  data() {
    return {
      store: useGlobalStore(),
      toggled: false,
      pendingOtjsReady: false,
    };
  },

  beforeMount() {
    this.getPendingOtjs();
    this.$sidebar.setRefreshOtjsCallback(this.getPendingOtjs);
    this.pollInterval = setInterval(this.getPendingOtjs, 5 * 60 * 1000);
  },

  beforeUnmount() {
    clearInterval(this.pollInterval);
  },

  computed: {
    userId() {
      return this.store.userId;
    },
    hasPendingOtjs() {
      return this.$sidebar.otjsToReview > 0;
    },
    showOtjBubble() {
      return this.hasPendingOtjs && this.$permissions.hasPermission('access_otj_inbox');
    },
    isVisible() {
      return REQUIRED_PERMISSIONS.some(permission => this.$permissions.hasPermission(permission));
    },
  },

  methods: {
    getPendingOtjs() {
      this.pendingOtjsReady = false;
      this.$logger.info('Fetching pending OTJ count', { userId: this.userId });
      this.$http.get(`/api/curriculum/admin/programmes/otj-entries/${this.userId}/count`)
        .then(response => {
          this.$logger.info('Successfully fetched pending OTJ count', { userId: this.userId });
          this.$sidebar.otjsToReview = response.data.pending_otj_count;
        })
        .catch(error => {
          this.$logger.autowarn('Error fetching pending OTJ count', { userId: this.userId }, error);
        }).then(() => {
          this.pendingOtjsReady = true;
        });
    },
  },
};
</script>
